import type { GlitterColors, Spark } from "./sparkModel.js";

function alphaOf(spark: Spark): number {
  return 1 - spark.life / spark.maxLife;
}

function drawDot(ctx: CanvasRenderingContext2D, spark: Spark, colors: GlitterColors) {
  const a = alphaOf(spark);
  const color = spark.color ?? colors.core;
  ctx.globalAlpha = a * 0.45;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(spark.x, spark.y, spark.size * 2.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.globalAlpha = a;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(spark.x, spark.y, spark.size, 0, Math.PI * 2);
  ctx.fill();
}

function drawStreak(ctx: CanvasRenderingContext2D, spark: Spark, colors: GlitterColors) {
  const a = alphaOf(spark);
  const color = spark.color ?? colors.core;
  const h = spark.len * (0.55 + 0.45 * a);
  ctx.globalAlpha = a * 0.85;
  ctx.fillStyle = color;
  ctx.fillRect(spark.x, spark.y - h / 2, spark.size, h);
  ctx.globalAlpha = a * 0.28;
  ctx.fillStyle = color;
  ctx.fillRect(spark.x - 1, spark.y - h / 2, spark.size + 2, h);
}

function drawTip(ctx: CanvasRenderingContext2D, x: number, y: number, colors: GlitterColors, pulse: number) {
  const r = 2.2 + pulse * 1.6;
  ctx.globalAlpha = 0.22 + pulse * 0.18;
  ctx.fillStyle = colors.bloom;
  ctx.beginPath();
  ctx.arc(x, y, r * 4.5, 0, Math.PI * 2);
  ctx.fill();
  ctx.globalAlpha = 0.95;
  ctx.fillStyle = colors.core;
  ctx.beginPath();
  ctx.arc(x, y, r, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillRect(x - 1, y - 7 - pulse * 6, 2, 14 + pulse * 12);
}

export function drawGlitterFrame(
  ctx: CanvasRenderingContext2D,
  w: number,
  h: number,
  sparks: Spark[],
  tipX: number,
  barY: number,
  moving: boolean,
  pulse: number,
  colors: GlitterColors,
) {
  ctx.clearRect(0, 0, w, h);
  ctx.globalCompositeOperation = "lighter";
  for (const spark of sparks) {
    if (spark.kind === "streak") drawStreak(ctx, spark, colors);
    else drawDot(ctx, spark, colors);
  }
  if (moving) drawTip(ctx, tipX, barY, colors, pulse);
  ctx.globalCompositeOperation = "source-over";
  ctx.globalAlpha = 1;
}
